import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

const designerCSS = css`
  img {
    width: 600px;
  }

  span {
    padding: 10px 30px;
    color: hsl(340, 88%, 46%);
    width: fit-content;
    font-size: 5rem;
    font-weight: 900;
    letter-spacing: -0.04em;
    border-radius: 0 0 10px 10px;
    font-family: 'Inter';
  }
`

const developerCSS = css``

export const BustedOverlayCSS = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;
  /* <dtransform: translate(-50%, -50%); */
  display: flex;
  flex-direction: column;
  align-items: center;

  ${designerCSS}
  ${developerCSS}
`
